import type { ReactNode } from "react";
import type { ZodObject, ZodRawShape } from "zod";
import type { z } from "@/zod";
import { DetailFieldSectionContext } from "./context/DetailFieldSectionContext";
import { cn } from "@/lib/utils";

export interface DetailFieldSectionProps<T extends ZodRawShape> {
  schema: ZodObject<T>;
  data: z.infer<ZodObject<T>>;
  module: string;
  children: ReactNode;
  className?: string;
}

export function DetailFieldSection<T extends ZodRawShape>({
  schema,
  data,
  module,
  children,
  className,
}: DetailFieldSectionProps<T>) {
  return (
    <DetailFieldSectionContext.Provider value={{ schema, data, module }}>
      <div className={cn("detail-section-grid", className)}>{children}</div>
    </DetailFieldSectionContext.Provider>
  );
}
